type CheckIsValidNominalValueProps = {
  currentNominalValue: number;
  newNominalValue: number;
};

export const checkIsValidNominalValue = ({
  currentNominalValue,
  newNominalValue,
}: CheckIsValidNominalValueProps): boolean => {
  if (newNominalValue <= 0) return false;
  if (newNominalValue >= currentNominalValue) return false;
  if (!Number.isInteger(currentNominalValue / newNominalValue)) return false;

  return true;
};
